import { REDUCE_ENDORSEMENT_RESULT } from '../../constants/actions/policy';

export function reduceEndorsementResult(payload) {
    return {
        type: REDUCE_ENDORSEMENT_RESULT,
        payload,
    };
}
